














import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import SearchCarrierProduct from '@/mixins/search-queries/search-carrier-product'
import { IQuoteCarrierProductInput } from '@/modules/Quote/interfaces/quote-form'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'

@Component({
  components: {
    AppTextSearch
  }
})
export default class QuoteFormCarrierProduct extends mixins(SearchCarrierProduct) {
  @Prop({ type: Object as () => IQuoteCarrierProductInput }) value!: IQuoteCarrierProductInput
  @Prop({ type: Object as () => CarrierProduct }) carrierProduct!: CarrierProduct

  get disable () {
    return !!this.carrierProduct
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
